export class RequisicaoDeCompra {}
